(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rivhex-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('rivhex-product-details')) {
    customElements.define('rivhex-product-details', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        const headings = Array.from(this.children).filter(node => node.tagName === 'H2');
        if (!headings.length) return;
        this.dataset.ready = 'true';
        headings.forEach(heading => {
          const details = document.createElement('details');
          details.className = 'rivhex-detail';
          const summary = document.createElement('summary');
          const content = document.createElement('div');
          content.className = 'rivhex-detail__content';
          heading.before(details);
          summary.append(heading);
          details.append(summary, content);
          let next = details.nextSibling;
          while (next && !(next.nodeType === 1 && next.tagName === 'H2')) {
            const current = next;
            next = next.nextSibling;
            content.append(current);
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
